import { Button, Icon, VFlow } from 'bold-ui'
import React, { useState } from 'react'

interface AdicionarCidadaoButtonProps {
  onClick?: () => void
  cidadaoId?: string
  formComponent: React.ReactNode
  dataTestId: string
}

export function AdicionarCidadaoButton(props: Readonly<AdicionarCidadaoButtonProps>) {
  const { cidadaoId, formComponent, dataTestId, onClick } = props

  const [adicionarMode, setAdicionarMode] = useState(!!cidadaoId)

  const handleClick = () => {
    setAdicionarMode(!adicionarMode)
    onClick?.()
  }

  return (
    <VFlow>
      <Button kind='primary' size='medium' onClick={handleClick} data-testid={dataTestId}>
        <Icon icon={adicionarMode ? 'angleUp' : 'angleDown'} style={{ marginRight: '0.5rem' }} />
        {adicionarMode ? 'Cancelar adição' : 'Adicionar cidadão'}
      </Button>
      {adicionarMode && formComponent}
    </VFlow>
  )
}
